<template>
  <!-- 検索結果の確定時に search_results_shown / search_zero_result を発火するためのトラッカー（表示はしない） -->
  <span aria-hidden="true" hidden />
</template>

<script setup lang="ts">
import { normalizeSearchKeyword } from '@/wabunka-src/common/utils/googleAnalytics/common/searchKeyword';
import { sendGAWabunkaSearchResultsShownEvent } from '@/wabunka-src/common/utils/googleAnalytics/events/searchResultsShown';
import { sendGAWabunkaSearchZeroResultEvent } from '@/wabunka-src/common/utils/googleAnalytics/events/searchZeroResult';

interface Props {
  /** SearchBox の生クエリ（PII ガードは送信時に適用する） */
  query: string;
  resultCount: number;
  loading: boolean;
}

const props = defineProps<Props>();

// 同一検索の二重発火を防ぐシグネチャ（正規化キーワード＋件数）。レンダーごとの重複発火を抑止する。
let lastSignature = '';

watch(
  () => [props.loading, props.query, props.resultCount] as const,
  ([loading, query, resultCount]) => {
    // ローディング中・空クエリ（空白のみ含む）は 1 検索成立としてカウントしない
    const keyword = normalizeSearchKeyword(query);
    if (loading || keyword.length === 0) return;

    const signature = `${keyword}::${resultCount}`;
    if (signature === lastSignature) return;
    lastSignature = signature;

    sendGAWabunkaSearchResultsShownEvent(keyword, resultCount);
    if (resultCount === 0) {
      sendGAWabunkaSearchZeroResultEvent(keyword);
    }
  },
  { immediate: true },
);
</script>
